export enum PartRequestEnum {
  InCreation = 1,
  InApproval = 2,
  Rejected = 3,
  Approved = 4,
}

export const PartRequestMap: Record<number, string> = {
  [PartRequestEnum.InCreation]: 'InCreation',
  [PartRequestEnum.InApproval]: 'InApproval',
  [PartRequestEnum.Rejected]: 'Rejected',
  [PartRequestEnum.Approved]: 'Approved',
};
